import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-lm-bg">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-lm-primary border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <div className="text-lm-text2 text-sm">Loading…</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
